const FORMAT_DATE = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };

export { FORMAT_DATE };
